import React, { useContext } from "react"
import "twin.macro"
import ProfilePhoto, { Width } from "../profilePhoto"
import Link from "next/link"
import { AuthContext } from "../../utils/context"
import { ProfileOnGetProfileFragment } from "../../graphql/generated/graphql"
import { ReactComponent as VerifiedSVG } from "../../assets/alert/verified.svg"
import { HCard } from "../../microformats"
import { ShareProfile } from "../shareProfile"

export interface ProfileHeaderProps {
  profile: ProfileOnGetProfileFragment
}
const ProfileHeader = (props: ProfileHeaderProps) => {
  const { profile } = props
  const { bio, link, name, profilePictureUrl, id } = profile
  const { username } = profile
  const { userId } = useContext(AuthContext)
  const isActive = userId === id

  const prettyLink = (link: string) => {
    // remove https://, remove www., remove query params, remove trailing slash
    return link
      .replace("https://", "")
      .replace("www.", "")
      .replace(/^([^?#]+).*/, "$1")
      .replace(/\/$/, "")
  }

  const Details = (
    <div tw="space-y-1">
      <h1 tw="text-md font-bold space-x-1.5 block tablet:(text-lg)">
        <span className={HCard.Name}>{name}</span>
        {profile.verified && <VerifiedSVG data-testid="verified-check" tw="w-5 h-5 inline-block relative -top-0.5" />}
      </h1>
      <div>
        <p tw="text-sm tablet:(text-md font-bold)" className={HCard.Bio}>
          {bio}
        </p>
        {!!link && (
          <p tw="text-sm tablet:(text-md font-bold)">
            <Link href={link} passHref>
              <a data-testid="profile-link" className={HCard.URL} target="_blank" rel="noopener noreferrer">
                {prettyLink(link)}
              </a>
            </Link>
          </p>
        )}
      </div>
    </div>
  )

  return (
    <header className={HCard.VCard}>
      <div tw="flex items-center">
        <ProfilePhoto
          name={name ?? ""}
          username={username}
          width={Width.W184}
          profilePictureUrl={profilePictureUrl}
          isActive={isActive}
        />
        <div tw="px-5">
          <div tw="flex items-center space-x-5 tablet-lg:space-x-10">
            <span tw="title-4 tablet:text-2xl tablet-lg:text-2xl desktop:text-3xl" data-testid="profile-name">
              {username}
            </span>
            <ShareProfile {...{ profile, isActive }} />
          </div>
          <span tw="hidden tablet-lg:inline-flex">{Details}</span>
        </div>
      </div>
      <span tw="pt-5 inline-flex tablet-lg:hidden">{Details}</span>
    </header>
  )
}

export default ProfileHeader
